import './BootSplashScreen.css';
import ocifLogo from '../assets/OCIF.png';

/**
 * Mirrors the static #boot-splash markup in index.html pixel-for-pixel so it can
 * stand in as a loading fallback anywhere in the React tree that renders before
 * the tenant theme (UWEThemeProvider) is available — at that point emotion's
 * Global styles (e.g. .logo-loader) haven't been injected yet, so a themed
 * Loader would paint unstyled. This component depends on nothing but plain CSS.
 */
function BootSplashScreen() {
  return (
    <div className="boot-splash-screen">
      <div className="boot-splash-brand">
        <svg xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="boot-shape-grid-react" x="0" y="0" width="84" height="84" patternUnits="userSpaceOnUse">
              <circle cx="14" cy="14" r="2.5" fill="none" stroke="white" strokeWidth="1.5" />
              <rect x="39.5" y="11.5" width="5" height="5" fill="none" stroke="white" strokeWidth="1.5" />
              <polygon points="70,11.5 72.2,15.25 67.8,15.25" fill="none" stroke="white" strokeWidth="1.5" />
              <rect x="11.5" y="39.5" width="5" height="5" fill="none" stroke="white" strokeWidth="1.5" />
              <polygon points="42,39.5 44.2,43.25 39.8,43.25" fill="none" stroke="white" strokeWidth="1.5" />
              <circle cx="70" cy="42" r="2.5" fill="none" stroke="white" strokeWidth="1.5" />
              <polygon points="14,67.5 16.2,71.25 11.8,71.25" fill="none" stroke="white" strokeWidth="1.5" />
              <circle cx="42" cy="70" r="2.5" fill="none" stroke="white" strokeWidth="1.5" />
              <rect x="67.5" y="67.5" width="5" height="5" fill="none" stroke="white" strokeWidth="1.5" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#boot-shape-grid-react)" />
        </svg>
        <div className="boot-splash-blob boot-splash-blob--1" />
        <div className="boot-splash-blob boot-splash-blob--2" />
        <div className="boot-splash-blob boot-splash-blob--3" />
      </div>
      <div className="boot-splash-panel">
        <div className="boot-splash-card">
          <div className="boot-splash-logo-loader">
            <img src={ocifLogo} alt="" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BootSplashScreen;
